import { render, staticRenderFns } from "./InvitationsCollaboratorTable.vue?vue&type=template&id=666e8974&scoped=true&"
import script from "./InvitationsCollaboratorTable.vue?vue&type=script&lang=js&"
export * from "./InvitationsCollaboratorTable.vue?vue&type=script&lang=js&"
import style0 from "./InvitationsCollaboratorTable.vue?vue&type=style&index=0&id=666e8974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e8974",
  null
  
)

export default component.exports